export enum TypeUser {
  ADMIN = "ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
  OFFICER = "OFFICER",
}
export enum ModulesType {
  FileModule = "FileModule",
  DocumentManagment = "DocumentManagment",
  Correspondence = "Correspondence",
  StockTacking = "StockTacking",
}

export enum TypeDocUsers {
  CC = "CC",
  CE = "CE",
  PASSPORT = "Pasaporte",
}
export enum VersionOffice {
  VERSION_1 = "1.0",
  VERSION_2 = "2.0",
  VERSION_3 = "3.0",
}

export enum ProductionOffice {
  HOGAR = "Hogar",
  JUDICIAL = "Judicial",
  JURIDICA = "Juridica",
}
export enum TypeEntity {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
}
export enum TypeDays {
  CALENDAR = "CALENDAR",
  BUSINESSDAYS = "BUSINESSDAYS",
}
export enum TypeInbox {
  ANNOTATION = "Annotation",
  OFFICIAL_COMMUNICATION = "OFFICIAL_COMMUNICATION",
  NO_OFFICIAL_COMMUNICATION = "NO_OFFICIAL_COMMUNICATION",
}
export enum CommunicationChannels {
  SINGLE_WINDOW = "01",
  EMAIL = "02",
  FACEBOOK = "03",
  WHATSAPP = "04",
  CALL = "05",
  INSTITUTIONAL_PAGE = "06",
  FAX = "07",
  SAC = "08",
  VERBAL_COMMUNICATION = "09",
  WEB_FORM = "10",
  BUZON = "11",
}

export const CommunicationChannelsList = [
  {
    value: CommunicationChannels.SINGLE_WINDOW,
    name: "chanel.SingleWindow",
  },
  {
    value: CommunicationChannels.EMAIL,
    name: "chanel.EmailAddress",
  },
  {
    value: CommunicationChannels.SAC,
    name: "chanel.sac",
  },
  {
    value: CommunicationChannels.VERBAL_COMMUNICATION,
    name: "chanel.VerbalCommunication",
  },
  {
    value: CommunicationChannels.FACEBOOK,
    name: "chanel.Facebook",
  },
  {
    value: CommunicationChannels.WHATSAPP,
    name: "chanel.Whatsapp",
  },
  {
    value: CommunicationChannels.CALL,
    name: "chanel.ByTelephone",
  },
  {
    value: CommunicationChannels.INSTITUTIONAL_PAGE,
    name: "chanel.InstitutionalPage",
  },
  {
    value: CommunicationChannels.FAX,
    name: "chanel.Fax",
  },
  {
    value: CommunicationChannels.BUZON,
    name: "chanel.Buzon",
  },
];

export enum CorrespondenceInputType {
  ER = "ER", //Externa recibida
  EP = "EP", //externa Producida
  IR = "IR", //interna recibida
  IP = "IP", // interna producida
  IPR = "IP-IR", // interna producida - interna producida
  OR = "OR", // otros recibidos
  OP = "OP", //otros producidos
}
export enum CorrespondenceStatus {
  IN_PROCESS = "InProcess",
  RESOLVED = "Resolved",
  INACTIVE = "Inactive", //cuando se elimine una correspondencia se cambiara a este estado
}

export enum InternalCorrespondenceStatus {
  RESPONSE_ISSUED_ONTIME = "Response_Issued_OnTime",
  EXTEMPORANEOUS_RESPONSE = "Extemporaneous_Response",
  UNANSWERED = "Unanswered",
  NO_ANSWER_REQUIRED = "No_Answer_Required",
}

export enum ContractingOffice {
  MAYOROFFICE = "Mayor_Office",
  SECRETARY_OF_GOVERNEMENT = "Secretary_Of_Government",
  PLANNING_SECRETARIAT = "Planning_Secretariat",
  FINANCIAL_SECRETARIAT = "Financial_Secretariat",
  POLICE_INSPECTION = "Police_Inspection",
}

export enum ActionSettled {
  RECLASSIFY = "ReclassifySettled",
  REASSIGN = "ReassignSettled",
  SEND_COPY = "SendCopyOfSettled",
  RETURN = "Return",
  APPROVED = "RequestForApproval",
  REQUEST_FOR_PROJECTION = "RequestForProjection",
  CLASSIFY_WITH_TRD = "ClassifyWithTRDTitle",
  ASSIGN_TO_FILE = "AssignToFile",
  ANNOTATION = "CreateAnnotation",
  UPLOAD_DOCUMENT = "AttachDocument",
  REQUEST_ADDITIONAL_INFORMATION = "RequestAdditionalInformation",
  ISSUANCE_OF_RESPONSE = "IssuanceOfResponse",
  ISSUANCE_VO_BO = "IssuanceOfVoBoToResponse",
  VO_BO_APPROVED = "VoBoApproved",
  VO_BO_REJECTED = "VoBoRejected",
  EDIT_EXPEDIENT = "UpdateFile",
  EXTENSION_REQUEST = "extensionRequest",
  SEND_EMAIL = "SendToEmail",
}

export enum TransferType {
  PRIMARY_TRANSFER = "PrimaryTransfer",
  SECONDARY_TRANSFER = "SecondaryTransfer",
}

export enum TypeArchive {
  MANAGEMENT_FILE = "ManagementFile",
  CENTRAL_ARCHIVE = "CentralArchive",
  HISTORICAL_ARCHIVE = "HistoricalArchive",
}
export enum SupportType {
  PAPER = "Paper",
  ELECTRONIC = "Electronic",
}
export enum Enum_Notification_Type {
  ER = "ER",
  EP = "EP",
  FA = "FA",
  SI = "SI",
  EXTENSION = "EX",
}

export enum Enum_FileSize {
  // 1000MB
  maxAllowedSize = 1000 * 1024 * 1024,
}

export enum LabelsSize {
  SIZE_89MM = 0,
  SIZE_10CM = 1,
  SIZE_10CM_V2 = 2,
}

export const TimeZones: Record<string, Record<string, string>> = {
  "US Pacific Baker": { code: "en-US", timeZone: "America/Los_Angeles" },
  "US Samoa": { code: "en-US", timeZone: "Pacific/Majuro" },
  Hawaii: { code: "en-US", timeZone: "Pacific/Honolulu" },
  "French Polynesia Marquesas": {
    code: "fr-PF",
    timeZone: "Pacific/Marquesas",
  },
  Alaska: { code: "en-US", timeZone: "America/Anchorage" },
  "US Pacific": { code: "en-US", timeZone: "America/Los_Angeles" },
  "Canada Pacific": { code: "en-CA", timeZone: "America/Vancouver" },
  "Mexico Baja California": { code: "es-MX", timeZone: "America/Tijuana" },
  "US Mountain": { code: "en-US", timeZone: "America/Denver" },
  "Canada Mountain": { code: "en-CA", timeZone: "America/Edmonton" },
  "Mexico Chihuahua": { code: "es-MX", timeZone: "America/Chihuahua" },
  "Mexico Central": { code: "es-MX", timeZone: "America/Mexico_City" },
  "Costa Rica": { code: "es-CR", timeZone: "America/Costa_Rica" },
  Guatemala: { code: "es-GT", timeZone: "America/Guatemala" },
  "El Salvador": { code: "es-SV", timeZone: "America/El_Salvador" },
  Honduras: { code: "es-HN", timeZone: "America/Tegucigalpa" },
  Nicaragua: { code: "es-NI", timeZone: "America/Managua" },
  Colombia: { code: "es-CO", timeZone: "America/Bogota" },
  Ecuador: { code: "es-EC", timeZone: "America/Guayaquil" },
  Peru: { code: "es-PE", timeZone: "America/Lima" },
  Panama: { code: "es-PA", timeZone: "America/Panama" },
  Jamaica: { code: "en-JM", timeZone: "America/Jamaica" },
  Venezuela: { code: "es-VE", timeZone: "America/Caracas" },
  Bolivia: { code: "es-BO", timeZone: "America/La_Paz" },
  "Dominican Republic": { code: "es-DO", timeZone: "America/Santo_Domingo" },
  Paraguay: { code: "es-PY", timeZone: "America/Asuncion" },
  "Canada Newfoundland": { code: "en-CA", timeZone: "America/St_Johns" },
  Argentina: { code: "es-AR", timeZone: "America/Argentina/Buenos_Aires" },
  Chile: { code: "es-CL", timeZone: "America/Santiago" },
  Uruguay: { code: "es-UY", timeZone: "America/Montevideo" },
  "Brazil Brasilia": { code: "pt-BR", timeZone: "America/Sao_Paulo" },
  "South Georgia": { code: "en-GS", timeZone: "Atlantic/South_Georgia" },
  "Falkland Islands": { code: "en-FK", timeZone: "Atlantic/Stanley" },
  "Cape Verde": { code: "pt-CV", timeZone: "Atlantic/Cape_Verde" },
  UK: { code: "en-GB", timeZone: "Europe/London" },
  Ireland: { code: "en-IE", timeZone: "Europe/Dublin" },
  Portugal: { code: "pt-PT", timeZone: "Europe/Lisbon" },
  Ghana: { code: "en-GH", timeZone: "Africa/Accra" },
  Iceland: { code: "is-IS", timeZone: "Atlantic/Reykjavik" },
  Morocco: { code: "ar-MA", timeZone: "Africa/Casablanca" },
  Senegal: { code: "fr-SN", timeZone: "Africa/Dakar" },
  Spain: { code: "es-ES", timeZone: "Europe/Madrid" },
  France: { code: "fr-FR", timeZone: "Europe/Paris" },
  Germany: { code: "de-DE", timeZone: "Europe/Berlin" },
  Italy: { code: "it-IT", timeZone: "Europe/Rome" },
  Belgium: { code: "nl-BE", timeZone: "Europe/Brussels" },
  Nigeria: { code: "en-NG", timeZone: "Africa/Lagos" },
  "South Africa": { code: "en-ZA", timeZone: "Africa/Johannesburg" },
  Egypt: { code: "ar-EG", timeZone: "Africa/Cairo" },
  Turkey: { code: "tr-TR", timeZone: "Europe/Istanbul" },
  Israel: { code: "he-IL", timeZone: "Asia/Jerusalem" },
  Greece: { code: "el-GR", timeZone: "Europe/Athens" },
  Ukraine: { code: "uk-UA", timeZone: "Europe/Kiev" },
  "Saudi Arabia": { code: "ar-SA", timeZone: "Asia/Riyadh" },
  Iraq: { code: "ar-IQ", timeZone: "Asia/Baghdad" },
  "Russia West": { code: "ru-RU", timeZone: "Europe/Moscow" },
  Kenya: { code: "sw-KE", timeZone: "Africa/Nairobi" },
  Yemen: { code: "ar-YE", timeZone: "Asia/Aden" },
  Iran: { code: "fa-IR", timeZone: "Asia/Tehran" },
  UAE: { code: "ar-AE", timeZone: "Asia/Dubai" },
  Armenia: { code: "hy-AM", timeZone: "Asia/Yerevan" },
  Azerbaijan: { code: "az-AZ", timeZone: "Asia/Baku" },
  Georgia: { code: "ka-GE", timeZone: "Asia/Tbilisi" },
  Oman: { code: "ar-OM", timeZone: "Asia/Muscat" },
  Afghanistan: { code: "fa-AF", timeZone: "Asia/Kabul" },
  Pakistan: { code: "ur-PK", timeZone: "Asia/Karachi" },
  Uzbekistan: { code: "uz-UZ", timeZone: "Asia/Tashkent" },
  Maldives: { code: "dv-MV", timeZone: "Indian/Maldives" },
  India: { code: "hi-IN", timeZone: "Asia/Kolkata" },
  "Sri Lanka": { code: "si-LK", timeZone: "Asia/Colombo" },
  Nepal: { code: "ne-NP", timeZone: "Asia/Kathmandu" },
  Bangladesh: { code: "bn-BD", timeZone: "Asia/Dhaka" },
  Bhutan: { code: "dz-BT", timeZone: "Asia/Thimphu" },
  Myanmar: { code: "my-MM", timeZone: "Asia/Yangon" },
  "Cocos Islands": { code: "en-CC", timeZone: "Indian/Cocos" },
  Thailand: { code: "th-TH", timeZone: "Asia/Bangkok" },
  Vietnam: { code: "vi-VN", timeZone: "Asia/Hanoi" },
  Cambodia: { code: "km-KH", timeZone: "Asia/Phnom_Penh" },
  Laos: { code: "lo-LA", timeZone: "Asia/Vientiane" },
  "Indonesia West": { code: "id-ID", timeZone: "Asia/Jakarta" },
  China: { code: "zh-CN", timeZone: "Asia/Shanghai" },
  Philippines: { code: "fil-PH", timeZone: "Asia/Manila" },
  Singapore: { code: "en-SG", timeZone: "Asia/Singapore" },
  Malaysia: { code: "ms-MY", timeZone: "Asia/Kuala_Lumpur" },
  "Hong Kong": { code: "zh-HK", timeZone: "Asia/Hong_Kong" },
  "Australia Eucla": { code: "en-AU", timeZone: "Australia/Eucla" },
  Japan: { code: "ja-JP", timeZone: "Asia/Tokyo" },
  "Korea South": { code: "ko-KR", timeZone: "Asia/Seoul" },
};

export const SUPPORTED_FORMATS_FILE = {
  TYPE: [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "image/jpeg",
    "image/png",
    "application/msword",
    "text/csv",
    "application/pdf",
    "application/zip",
    "application/x-zip-compressed",
    "application/vnd.rar",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.oasis.opendocument.text",
  ],
};
